import { PropsWithChildren } from 'react'
import { styled } from '@mui/material'
import { IconButton } from '@carto/meridian-ds/components'
import { ContextMenuBase } from './ContextMenuBase'
import { ContextMenuList } from './ContextMenuList'
import { ContextMenuIconProps } from './interfaces'

const IconButtonStyled = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'buttonSelected'
})<{
  buttonSelected?: boolean
}>(({ theme: { palette }, buttonSelected }) => ({
  backgroundColor: buttonSelected ? palette.action.hover : 'transparent'
}))

export function ContextMenuIcon({
  children,
  menuItems,
  onClickItem,
  placement,
  popperClassName,
  fullWidth,
  elevation,
  alignRight,
  className,
  ButtonComponent,
  dense,
  extended,
  mobileMode,
  menuTitle,
  disablePortal = false,
  buttonSelected = false,
  isOpen,
  MenuListComponent = ContextMenuList,
  'data-testid': dataTestId,
  ...iconButtonProps
}: PropsWithChildren<ContextMenuIconProps>) {
  return (
    <ContextMenuBase
      data-testid={dataTestId}
      menuItems={menuItems}
      isOpen={isOpen}
      onClickItem={onClickItem}
      placement={placement}
      popperClassName={popperClassName}
      fullWidth={fullWidth}
      elevation={elevation}
      alignRight={alignRight}
      className={className}
      dense={dense}
      extended={extended}
      mobileMode={mobileMode}
      menuTitle={menuTitle}
      disablePortal={disablePortal}
      MenuListComponent={MenuListComponent}
      ButtonComponent={
        ButtonComponent
          ? ButtonComponent
          : ({ onClick }) => (
              <IconButtonStyled
                {...iconButtonProps}
                onClick={onClick}
                buttonSelected={buttonSelected}
                icon={children}
              />
            )
      }
    />
  )
}
